import axios from 'axios';


export const doDownloadStudy = (downloadZipUrl) => {
  let link = document.createElement('a');
  link.href = downloadZipUrl.current;
  link.dispatchEvent(new MouseEvent('click'));
};

export const handleDownloadIamges = async (
  accountId, checkDownloadLink, checkInterval, downloadImagesLink,
  downloadZipUrl, patientName, setDownloadStatus, studyId, user
) => {
  try {
    setDownloadStatus('zipping');

    const { shortKey, downloadUrl } = await axios
      .get(downloadImagesLink)
      .then((res) => res.data);

    downloadZipUrl.current = downloadUrl;

    let id = setInterval(checkDownload, checkInterval);

    async function checkDownload() {
      const result = await axios
        .get(`${checkDownloadLink}&shortKey=${encodeURIComponent(shortKey)}`)
        .then((res) => res.data)
        .catch((e) => {
          clearInterval(id);
          setDownloadStatus(e.toString());
        });
      if (result === true) {
        clearInterval(id);
        setDownloadStatus('done');

        axios.post('/external/insertResultsPortalLogs', {
          type: 'resultsPortal',
          subType: 'downloadImages',
          studyId,
          patientName,
          accountId,
          user: {
            username: user.username,
            typeUser: user.type === 'medico'
              ? 'Médico solicitante'
              : user.type === 'paciente' ? 'Paciente' : 'Prestador'
          }
        }).then(() => {}).catch((err) => { console.error(err); });
      }
    }
  } catch(e) {
    console.log('Error downloading zip: ', e.toString());
    setDownloadStatus(e.toString());
  }
}